import BaseVM from './base-vm';

import VideoEditorVM from './video-editor-vm';
import IframeMediaVM from './iframe-media-vm';
import DocumentMediaVM from './document-media-vm';
import ImageMediaVM from './image-media-vm';
import DICOMMediaVM from './dicom-media-vm';
import AWS from "aws-sdk"

class ContentViewModel {
  constructor() { this.init.apply(this, arguments); }
}

const mediaVMs = {
  NativeMediaVM: VideoEditorVM,
  HostedVideoVM: VideoEditorVM,
  IframeMediaVM,
  DocumentMediaVM,
  ImageMediaVM,
  DICOMMediaVM,
}

ContentViewModel.prototype = Kadenze.Util.extendClass(BaseVM, {
  addingMedia: ko.observable(false),
  addingDocuments: ko.observable(false),
  saving: ko.observable(false),
  numMediaPanesOpen: 0,
  imageTypes: 'image/jpeg, image/jpg, .jpeg, .jpg, .png, image/png',
  dicomTypes: 'application/dicom, .dcm',
  documentTypes:
      'application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.wordperfect, application/vnd.ms-works, text/csv, .xslx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .pps, application/vnd.openxmlformats-officedocument.presentationml.slideshow, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.oasis.opendocument.presentation, application/vnd.oasis.opendocument.text, application/vnd.oasis.opendocument.spreadsheet',

  init (data, wizard) {
    this.super('init', wizard, data);

    this.mapping = {
      include: [
        'lecture_media_attributes',
        'document_conversion_job_attributes'
      ],

      lecture_media: {
        create: options => {
          const type = options.data.type;

          if (mediaVMs[`${type}VM`]) {
            return new mediaVMs[`${type}VM`](options.data);
          } else {
            return options.data;
          }
        }
      },

      languages: {
        create: options => JSON.parse(options.data),
      }
    };

    ko.mapping.fromJS(data, this.mapping, this);

    this.hasMedia = ko.computed(() => !!this.lecture_media().length)

    this.mediaTypeCount = type => {
      return this.lecture_media().filter(m => m.type == `${type}Media`).length
    };

    this.documentCount = ko.computed(() => this.mediaTypeCount('Document'));

    this.imageCount = ko.computed(() => this.mediaTypeCount('Image'));

    this.mediaCount = ko.computed(
      () => this.lecture_media().filter(
        m => m.type != 'DocumentMedia' && m.type != 'ImageMedia'
      ).length
    );

    this.totalMediaDuration = ko.computed(() => this.getTotalDuration());

    if (!this.document_conversion_jobs())
      this.document_conversion_jobs([]);
  },

  initUI () {
    this.initalized = true;
    this.initFileDropUiJs();
    // this.initializeSessionMediaDropzone(); // NOT NEEDED
    this.makeMediaSortable();
    this.orderSessionMedia();
    this.delegateEvents();
  },

  delegateEvents () {
    $('#hosted-media-url').on('keyup', e => {
      if (e.keyCode == 13)
        this.addHostedLectureMedia();
    });
  },

  rowReveal (el, _ix, _data) {
    Kadenze.UIUtil.toggleElementHighlight($(el).next(), 1000);
  },

  getRowId (media) {
    const root = "js-media-";

    if (typeof media.id === 'function') {
      return `${root}${media.id()}`;
    } else {
      return `${root}${media.id}`;
    }
  },

  toggleAddMedia () {
    this.addingMedia(!this.addingMedia());
  },

  toggleAddDocuments () {
    this.addingDocuments(!this.addingDocuments());
  },

  requestFail (xhr) {
    xhr.responseJSON ||= { errors: xhr.errors }

    const { responseJSON: { errors } } = xhr

    errors.forEach(error => new Kadenze.Notice.error({ message: error }));
  },

  // initializeSessionMediaDropzone () {
  //   const maxFilesize = 2000;
  //   const selector = '#session-media-dz';

  //   try {
  //     if (Dropzone.forElement(selector))
  //       return;
  //   } catch { }

  //   const $message = $(JST['templates/dropzone-generic']({
  //     title: I18n.t('drop_file_editor.session_content_title'),
  //     hideUpperTitle: true,
  //     maxFilesize,
  //     acceptedFiles: 'Image, Video, Audio, or Document',
  //     dropFilesTitle: I18n.t('drop_file_editor.drop_file_title'),
  //     dragAndDrop: I18n.t('drop_file_editor.drag_and_drop'),
  //     browseFiles: I18n.t('drop_file_editor.browse_files'),
  //     dimentionLabel: I18n.t('drop_file_editor.dimensions_label'),
  //     maxFilesizeLabel: I18n.t('drop_file_editor.max_file_size'),
  //     fileTypesLabel: I18n.t('drop_file_editor.file_types'),
  //     optionalLable: I18n.t('drop_file_editor.optional'),
  //   }));

  //   const $previewTemplate = $(
  //     I18n.tt(
  //       JST['templates/dropzone-session-media-preview']({ status: 'uploading' })
  //     )
  //   );

  //   const acceptedFiles = `video/*, video/mp4, audio/wav, application/ogg, .mp3, ${this.imageTypes}, ${this.documentTypes}, ${this.dicomTypes}`;

  //   const opts = {
  //     url: Kadenze.Routes.lecture_media_path(),
  //     previewsContainer: document.getElementById('session-media-preview'),
  //     previewTemplate: $previewTemplate[0].outerHTML,
  //     autoProcessQueue: true,
  //     paramName: 'lecture_medium[media_src]',
  //     acceptedFiles,
  //     maxFilesize,
  //     chunking: true,
  //     forceChunking: true,
  //     chunkSize: 1 * 1000 * 1000 * 1000, // bytes
  //   };

  //   const callbacks = {
  //     chunksUploaded: (file, doneFn) => doneFn(file),

  //     done: function(file) { this.trigger('complete', file) },

  //     success: file => this.updateClientWithNewMedia(file),

  //     uploadprogress: (file, _progress, bytesSent) => {
  //       const progress = bytesSent / file.size * 100
  //         // https://gitlab.com/meno/dropzone/-/issues/54

  //       $('.js-step-completeMeter', file.previewTemplate)
  //         .css('width', `${progress}%`);

  //       if (progress > 99)
  //         $('.js-step-cancel', file.previewtemplate).off().addClass('disabled');
  //     },

  //     sending: (file, _response, formData) => {
  //       this.addingMedia(false);

  //       if (this.id())
  //         formData.append('lecture_medium[lecture_id]', this.id());

  //       if (this.isDocument(file)) {
  //         this.appendMediaDetails(file, formData, 'Document');
  //       } else if (this.isImage(file)) {
  //         this.appendMediaDetails(file, formData, 'Image');
  //       } else if (this.isDICOM(file)) {
  //         this.appendMediaDetails(file, formData, 'DICOM');
  //       } else {
  //         this.appendMediaDetails(file, formData, 'Native');
  //       }

  //       formData.append('lecture_medium[media_type]', file.type);

  //       $('.js-step-cancel', file.previewTemplate).on('click', () => {
  //         mediaDZ.removeFile(file);

  //         Kadenze.Ajax.delete({
  //           routeName: 'lecture_medium',
  //           routeParams: file.upload.uuid,
  //           $parent: $previewTemplate,
  //         })

  //         this.addingMedia(true);
  //       });
  //     },

  //     addedfile: () => this.handlePreview(mediaDZ),

  //     error: (_file, err) => this.requestFail(err),

  //     complete: file => {
  //       mediaDZ.removeFile(file);
  //       this.handlePreview(mediaDZ);
  //     },
  //   };

  //   const mediaDZ = new Kadenze.MediaDropZone(
  //     $(selector),
  //     $message,
  //     opts,
  //     callbacks,
  //     false
  //   );

  //   $(mediaDZ.element).removeClass('dz-unit');
  // },

  initFileDropUiJs() {
    window.supportDrag = function () {
      let div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    }();

    let input = document.getElementById('upload_lecture_medium_file');

    if (!supportDrag) {
      document.querySelectorAll('.has-drag')[0].classList.remove('has-drag');
    }

    input.addEventListener("change", function (e) {
      document.getElementById('js-file-name').innerHTML = this.files[0]?.name ?? "No file selected";
      document.querySelectorAll('.file-input')[0].classList.remove('file-input--active');
    }, false);

    if (supportDrag) {
      input.addEventListener("dragenter", function (e) {
        document.querySelectorAll('.file-input')[0].classList.add('file-input--active');
      });

      input.addEventListener("dragleave", function (e) {
        document.querySelectorAll('.file-input')[0].classList.remove('file-input--active');
      });
    }
  },
  
  // Identify media type based on MIME type
  identifyMediaType(file) {
    if (this.isDocument(file)) {
      return 'DocumentMedia';
    } else if (this.isImage(file)) {
      return 'ImageMedia';
    } else {
      return 'NativeMedia';
    }
  },

  uploadLectureMedia(lecture_id, current_tenant) {
    const fileInput = document.getElementById('upload_lecture_medium_file');
    const upload_access = JSON.parse($('#session_json').val()).upload_access;
    if (fileInput.files.length > 0) {
      const parent_obj = this;
      const file = fileInput.files[0];
      const fileName = file.name;
      const bucketName = upload_access.direct_upload_bucket;
      const key = current_tenant + '/uploads/lecture_medium/' + Math.floor(Date.now() / 1000) + '/file/' + fileName;
      const mimeType = file.type;
      const mediaType = this.identifyMediaType(file);

      $('.file-infos').hide();
      $('#upload_lecture_medium_file').hide();
      $('#cancel-upload-btn').show();

      AWS.config.update({
        accessKeyId: upload_access.direct_upload_aws_access_key,
        secretAccessKey: upload_access.direct_upload_aws_secret_key,
        region: upload_access.direct_upload_region
      });

      const s3 = new AWS.S3();

      var params = {
        Bucket: bucketName,
        Key: key,
        Body: file,
        ACL: 'public-read'
      };

      var options = {
        partSize: 10 * 1024 * 1024,
        queueSize: 1
      };

      var request = s3.upload(params, options);

      $('#cancel-upload-btn, .cancel-upload-btn-by-cancle').click(function () {
        request.abort();
        $('#progress-bar-txt').html('');
        $('#upload_lecture_medium_file').val(null);
        $('.step-progress-unit').addClass('is-hidden');
        $('.js-step-completeMeter').css({ 'width': '0%' });
      });

      request.on('httpUploadProgress', function (evt) {
        var percentComplete = Math.round((evt.loaded / evt.total) * 100);
        $('#progress-bar-txt').html(percentComplete + '%')
        $('.step-progress-unit').removeClass('is-hidden');
        $('.js-step-completeMeter').css({ 'width': '' + percentComplete + '%' });
      });

      request.send(function (err, data) {
        if (err) {
          console.log(err);
          $('.file-infos').show();
          $('#upload_lecture_medium_file').show();
          $('#cancel-upload-btn').hide();
          document.getElementById('js-file-name').innerHTML = "No file selected"
        } else {
          console.log('Successfully uploaded video.');
          if (data.Location) {
            if (lecture_id == 0) { lecture_id = null }
            var params = { lecture_id: lecture_id, data: data, mimeType: mimeType, mediaType: mediaType }
            Kadenze.Ajax.post({
              routeName: "lecture_media",
              data: params,
              done: response => {
                $('#progress-bar-txt').html('');
                $('#upload_lecture_medium_file').val(null);
                $('.step-progress-unit').addClass('is-hidden');
                $('.js-step-completeMeter').css({ 'width': '0%' });
                parent_obj.updateClientWithNewMedia({ xhr: { response: response } });
                parent_obj.addingMedia(false);
                $('.file-infos').show();
                $('#upload_lecture_medium_file').show();
                $('#cancel-upload-btn').hide();
                document.getElementById('js-file-name').innerHTML = "No file selected"
              }
            });
          }
        }
      });
    }
  },

  appendMediaDetails(file, formData, type) {
    formData.append('lecture_medium[type]', `${type}Media`);
    formData.append('lecture_medium[name]', file.name);
  },

  handlePreview(mediaDz) {
    const $preview = $(mediaDz.previewsContainer);

    if (!$preview.children().length) {
      $preview.addClass('is-hidden');
    } else {
      $preview.removeClass('is-hidden');
    }
  },

  makeMediaSortable () {
    $('.js-sortable', '#session-media-table').sortable({
      items: '.display-table__data.editable',
      handle: '.display-table__sort-handle',
      update: (_e, _ui) => {
        this.orderSessionMedia();
      }
    });
  },

  orderSessionMedia () {
    $('.display-table__data.editable', '#session-media-table').each(
      (idx, item) => {
        const media = ko.dataFor(item);
        media.order(idx + 1);

        $('.display-table__data.editable:odd')
          .css('background-color', '#f4f4f4');

        $('.display-table__data.editable:even')
          .css('background-color', '#fffff');
      }
    );
  },

  updateMediaTitle (media) {
    Kadenze.UIUtil.toggleElementHighlight($('#media-title-' + media.id()), 1000);
  },

  duration (seconds) {
    let timeStr = 'n/a';

    if (seconds) {
      seconds = Math.round(seconds);
      const t = new Date(1970, 0, 1);
      t.setSeconds(seconds);
      timeStr = t.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
    }

    return timeStr;
  },

  addHostedLectureMedia () {
    const vurl = Kadenze.IframeMediaPlayer.extractUrl(
      $('#hosted-media-url').val()
    );

    const isIframe = Kadenze.IframeMediaPlayer.isIframe(vurl);

    const data = { lecture_medium: { lecture_id: this.id() } };

    if (!vurl) {
      new Kadenze.Notice.error({
        message: I18n.t('validation.embedded_video_url.invalid')
      });

      return;
    }

    if (isIframe) {
      data.lecture_medium.media_src = Kadenze.IframeMediaPlayer.parseURL(vurl);
      data.lecture_medium.alternate_src = vurl;
      data.lecture_medium.media_type = 'iframe';
      data.lecture_medium.type = 'IframeMedia';
    } else {
      data.lecture_medium.media_src = vurl;
      data.lecture_medium.media_type = 'vimeo/youtube';
      data.lecture_medium.type = 'HostedVideo';
    }

    this.saving(true);

    Kadenze.Ajax.post({
      routeName: "lecture_media",
      data: data,
      loadingContainer: this.$container,
      done: response => {
        this.saving(false);
        $('#hosted-media-url').val('');
        this.updateClientWithNewMedia({ xhr: { response: response } });
        this.addingMedia(false);
      },
      fail: this.requestFail,
    });
  },

  updateClientWithNewMedia({ xhr: { response } }) {
    const resp = typeof response === 'object' ?
      response :
      JSON.parse(response);

    const media = typeof resp.lecture_medium === 'object' ?
      resp :
      JSON.parse(resp.lecture_medium);

    if (!this.lecture_media().find(lm => lm.id() === media.id)) {
      this.lecture_media.mappedCreate(media);
      this.orderSessionMedia();
    }
  },

  deleteSessionMedia (vm, media) {
    Kadenze.UIUtil.confirmAction(
      I18n.t('session.media.confirm_delete_media'),
      () => vm.deleteMedia(media)
    );
  },

  deleteDoc (doc) {
    Kadenze.UIUtil.confirmAction(
      I18n.t('session.media.confirm_delete_media'),
      () => this.removeDoc(doc)
    );
  },

  deleteMedia (media) {
    Kadenze.Ajax.delete({
      routeName: "lecture_medium",
      routeParams: media.id(),
      $parent: $(`#js-media-${media.id()}`),
      data: { course_id: this.course_id() },
      done: data => {
        this.lecture_media.remove(media);
        this.orderSessionMedia();
      },
    });
  },

  removeDoc (doc) {
    this.prepareData();

    Kadenze.Ajax.delete({
      routeName: "document_conversion_job",
      routeParams: doc.id(),
      data: { job: ko.toJSON(doc) },
      done: () => {
        this.document_conversion_jobs.remove(doc);
        new Kadenze.Notice.success({ message: 'Removed document.' });
      },
    });
  },

  previewDoc (doc) {
    window.open(Kadenze.Routes.document_conversion_job_path(doc.id()));
  },

  reBind (session) {
    this.lecture_media([]);
    session.lecture_media.forEach(m => this.lecture_media.mappedCreate(m));
  },

  isDocument (file) {
    return this.isFileType(file, this.documentTypes);
  },

  isImage (file) {
    return this.isFileType(file, this.imageTypes);
  },

  isDICOM (file) {
    return this.isFileType(file, this.dicomTypes);
  },

  isFileType (file, types) {
    const content = file.type.split('/')[1];
    const ext = file.name.substr(file.name.lastIndexOf('.') + 1);
    const mime = file.type;

    return !!(types.match(content) || types.match(ext) || types.match(mime))
  },

  hasData () {
    const hasContent = typeof this.content != 'undefined' && this.content != '';
    return this.hasMedia() || hasContent;
  },

  getTotalDuration () {
    const total = this.lecture_media()
      .filter(m => !!m.duration)
      .map(m => parseInt(m.duration(), 10))
      .reduce((acc, value) => acc + value, 0)

    return this.duration(total);
  },

  getSummary () {
    let overviewItems = [
      {
        title: `${I18n.t('session.publish_summary.session_media.videos_added')} :`,
        description: this.mediaCount
      },

      {
        title: `${I18n.t('session.publish_summary.session_media.total_duration')} :`,
        description: this.totalMediaDuration
      },

      {
        title: `${I18n.t('session.publish_summary.session_media.documents_added')} :`,
        description: this.documentCount
      },

      {
        title: `${I18n.t('session.publish_summary.session_media.images_added')} :`,
        description: this.imageCount
      },
    ];

    if (Kadenze.isKadenze)
      overviewItems = overviewItems.slice(0, 2);

    const heading = I18n.t('session.publish_summary.session_media.heading')

    return {
      id: 2, // allows KO to update items easily
      heading,
      overviewItems,
    };
  },

  prepareData () {
    this.document_conversion_job_ids(
      this.document_conversion_jobs().map(j => j.id())
    );

    if (!this.id()) {
      this.lecture_media_attributes = this.lecture_media();
      this.__ko_mapping__.include.push('lecture_media_attributes');

      return;
    } else {
      if (this.__ko_mapping__.include.indexOf('lecture_media_ids') > -1) {
        this.__ko_mapping__.include.splice(
          this.__ko_mapping__.include.indexOf('lecture_media_ids'),
          1
        );
      }

      this.lecture_media_ids = null;
    }

    if (!this.lecture_media) return;

    this.lecture_media().forEach(media => {
      if (media.media_cues) {
        const cues = ko.isObservable(media.media_cues) ?
          media.media_cues() :
          media.media_cues;

        const formattedCues = cues.map(cue => {
          const rawCue = ko.mapping.toJS(cue);

          if (rawCue.cued) {
            rawCue.cued_attributes = rawCue.cued;
            delete rawCue.cued;
          }

          if (rawCue.id && rawCue.id < 0)
            delete rawCue.id; // remove temporary 'new' rawCue ids

          // this should be removed by mapping.toJS but for some reason is not
          delete rawCue.__ko_mapping__;
          return rawCue;
        });

        media.media_cues_attributes = formattedCues;
      }
    });

    // ignore attributes the server doesn't care about,
    // it's done here so they're only ignored when mapped
    // BACK to js not FROM js.
    this.__ko_mapping__.ignore.push('lecture_media', 'media_cues');
    this.lecture_media_attributes = this.lecture_media;
  }
});

export default ContentViewModel;
